export class AbstractError extends Error {
  constructor(message = '', cause = null) {
    super(message);
    this.name = this.constructor.name;
    this.cause = cause;
  }
}